import { BulkUpdateResult, Progress, ProgressBulkEditRequest, ProgressBulkSettingInterviewRequest, ProgressCheckResponse, ProgressCreateRequest, ProgressHistoryRemarksUpdateRequest, ProgressKpiResponse, ProgressOverwriteRequest, ProgressScreeningRequestStatus, ProgressScreeningRequestStatusHistory, ProgressSearchParams, ProgressSearchResponse, ProgressSettingSubScreeningAdjustRequest, ProgressStakeholderEmailResponse, ProgressSubScreeningStatus, ProgressSubScreeningStatusUpdateWithActionRequest, ProgressUpdateWithActionRequest, ProgressUpdateWithoutActionRequest, } from '@agent-ds/shared/interfaces';
import { ApiService } from '@agent-ds/shared/models/api-service';
import { toAsialRequestParameters } from '@agent-ds/shared/util/util';
import { HttpClient } from '@angular/common/http';
import { REPORT_SUCCESS_HEADER } from '../auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ProgressApiService extends ApiService {
    constructor(http) {
        super();
        this.http = http;
    }
    addProgress(request) {
        return this.http.post('/api/progress', request, { headers: { [REPORT_SUCCESS_HEADER]: 'TRUE' } });
    }
    getList(params) {
        return this.http.get('/api/progress/search', {
            params: toAsialRequestParameters(params),
        });
    }
    updateUsers(progressId, users) {
        return this.http.put(`/api/progress/${progressId}/users`, users);
    }
    updateHistoryRemarks(progressId, revision, remarks) {
        return this.http.put(`/api/progress/${progressId}/history/${revision}`, remarks);
    }
    updateWithAction(progressId, requestObject) {
        const markedRequestObject = this.markMachAction(requestObject);
        return this.http.put(`/api/progress/${progressId}`, markedRequestObject);
    }
    updateWithoutAction(progressId, requestObject) {
        return this.http.put(`/api/progress/${progressId}/no-action`, requestObject);
    }
    delete(progressId) {
        return this.http.delete(`/api/progress/${progressId}`);
    }
    getDetail(progressId) {
        return this.http.get(`/api/progress/${progressId}`);
    }
    revertHistory(progressId, revision, remarks) {
        return this.http.put(`/api/progress/${progressId}/revert/${revision}`, null, { params: { remarks: remarks } });
    }
    bulkRegisterStudent(studentId, jobIds) {
        return this.http.put(`/api/progress/bulk/student/${studentId}/register`, {
            jobIds: jobIds,
        });
    }
    bulkRegisterStudentsByJobId(jobId, studentIds) {
        return this.http.put(`/api/progress/bulk/job/${jobId}/register`, {
            studentIds: studentIds,
        });
    }
    bulkRegisterStudentsByProgressIds(progressIds) {
        return this.http.put('/api/progress/bulk/waiting-student-ok/overwrite', {
            progressIds: progressIds,
        });
    }
    bulkRecommendStudent(studentId, jobIds) {
        return this.http.put(`/api/progress/bulk/student/${studentId}/recommend`, {
            jobIds: jobIds,
        });
    }
    bulkRegisterStudentNoUpdate(studentId, jobIds) {
        return this.http.put(`/api/progress/bulk/student/${studentId}/register/no-update`, {
            jobIds: jobIds,
        });
    }
    bulkDecline(progressIds) {
        return this.http.put('/api/progress/bulk/end', { progressIds: progressIds });
    }
    bulkEdit(progressIds, request) {
        return this.http.put('/api/progress/bulk/edit', {
            progressIds: progressIds,
            fromStatus: request.fromStatus,
            toStatus: request.toStatus,
            stopReason: request.stopReason,
            remarks: request.remarks,
        });
    }
    bulkSettingInterview(request) {
        return this.http.put('/api/progress/bulk/setting-interview', request);
    }
    bulkSettingSubScreening(request) {
        return this.http.put('/api/progress/sub-screening/bulk/setting-schedule', request);
    }
    // includeResumeCheck を渡さない既存の呼び出し元は、クエリにキーが付かずレスポンスも一切変わらない
    checkProgress(studentIds, jobIds, includeResumeCheck = false) {
        const params = { studentIds: studentIds, jobIds: jobIds };
        if (includeResumeCheck) {
            params.includeResumeCheck = true;
        }
        return this.http.get('/api/progress/check', {
            params: toAsialRequestParameters(params),
        });
    }
    getStakeholders(progressIds) {
        return this.http.get('/api/progress/stakeholders/email', {
            params: toAsialRequestParameters({ progressIds: progressIds }),
        });
    }
    overwrite(progressId, requestObject) {
        return this.http.put(`/api/progress/${progressId}/overwrite`, requestObject);
    }
    getContractInfo(progressId) {
        return this.http.get(`/api/progress/${progressId}/contract-info`);
    }
    getReportRapa(date, teamId) {
        return this.http.get('/api/progress/monthly-kpi/rapa', { params: Object.assign({}, date, { teamId: teamId + '' }) });
    }
    getReportCa(date, teamId) {
        return this.http.get('/api/progress/monthly-kpi/ca', { params: Object.assign({}, date, { teamId: teamId + '' }) });
    }
    ngEnd(progressIds) {
        return this.http.put('/api/progress/bulk/ng-end', { progressIds: progressIds });
    }
    bulkCreate(jobIds, studentIds) {
        return this.http.post('/api/progress/bulk', { jobIds: jobIds, studentIds: studentIds });
    }
    bulkCreateStudent(studentId, jobIds, request) {
        return this.http.post(`/api/progress/bulk/student/${studentId}`, Object.assign({}, request, { jobIds: jobIds }));
    }
    bulkCreateJob(jobId, studentIds, request) {
        return this.http.post(`/api/progress/bulk/job/${jobId}`, Object.assign({}, request, { studentIds: studentIds }));
    }
    bulkCreateCombination(combinations) {
        return this.http.post(`/api/progress/bulk/combination`, {
            studentIdJobIds: combinations,
        });
    }
    // 進捗対応事項ステータス一覧取得
    getProgressScreeningRequestStatusList(progressId) {
        return this.http.get(`/api/progress/${progressId}/progress-screening-request-status-list`, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    // 進捗対応事項ステータス履歴一覧取得
    getProgressScreeningRequestStatusHistoryList(progressId) {
        return this.http.get(`/api/progress/${progressId}/progress-screening-request-status-history-list`, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    // 進捗対応事項ステータス登録
    createProgressScreeningRequestStatus(progressId, progressScreeningRequestStatus) {
        return this.http.post(`/api/progress/${progressId}/progress-screening-request-status`, progressScreeningRequestStatus, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    // 進捗対応事項ステータス更新
    updateProgressScreeningRequestStatus(id, progressId, progressScreeningRequestStatus) {
        return this.http.put(`/api/progress/${progressId}/progress-screening-request-status/${id}`, progressScreeningRequestStatus, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    /**
     * メイン選考の対応事項タイプ名を同期
     */
    syncMainScreeningRequestType(progressId, requestType) {
        return this.http.put(`/api/progress/${progressId}/progress-screening-request-status/main/type`, {
            requestType
        });
    }
    // 進捗対応事項期限更新
    updateScreeningRequestDeadlines(progressId, seminarAt, jobScreeningInfoId) {
        return this.http.put(`/api/progress/${progressId}/screening-requests/calculate-deadlines`, {
            seminarAt,
            jobScreeningInfoId
        });
    }
    // 進捗サブステータス対応事項期限更新
    updateSubScreeningRequestDeadlines(progressId, subStatusId, scheduledAt, jobScreeningInfoId) {
        return this.http.put(`/api/progress/${progressId}/sub-screening-requests/${subStatusId}/calculate-deadlines`, {
            scheduledAt,
            jobScreeningInfoId
        });
    }
    // 進捗対応事項ステータス削除
    deleteProgressScreeningRequestStatus(id, progressId) {
        return this.http.delete(`/api/progress/${progressId}/progress-screening-request-status/${id}`, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    // 進捗サブ選考開始
    startProgressSubScreening(progressId, progressSubScreeningStatus) {
        return this.http.post(`/api/progress/${progressId}/sub-screening-start`, progressSubScreeningStatus, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    // 進捗サブ選考更新
    updateProgressSubScreening(progressId, id, progressSubScreeningStatus) {
        return this.http.put(`/api/progress/${progressId}/sub-screening/${id}`, progressSubScreeningStatus, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    updateProgressScreeningRequestStatusWithAction(progressId, id, requestObject) {
        return this.http.put(`/api/progress/${progressId}/sub-screening/${id}/with-action`, requestObject);
    }
    // 進捗サブ選考ステータス一覧取得
    getProgressSubScreeningList(progressId) {
        return this.http.get(`/api/progress/${progressId}/sub-screening-list`, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    // 進捗サブ選考停止
    stopProgressSubScreening(progressId, id) {
        return this.http.delete(`/api/progress/${progressId}/sub-screening/${id}`, {
            headers: { [REPORT_SUCCESS_HEADER]: "TRUE" }
        });
    }
    bulkSeminarSchedule(progressIds, jobSettingSeminarScheduleId) {
        return this.http.put("/api/progress/bulk/seminar-schedule", { progressIds, jobSettingSeminarScheduleId });
    }
    markMachAction(request) {
        const MACH_ACTIONS = [
            72,
            74,
            75,
            76,
            102,
            105 // 面接案内送信
        ];
        return MACH_ACTIONS.includes(request.action)
            ? Object.assign({}, request, { isFromMach: true }) : request;
    }
}
ProgressApiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProgressApiService_Factory() { return new ProgressApiService(i0.ɵɵinject(i1.HttpClient)); }, token: ProgressApiService, providedIn: "root" });
